import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "影片分类", to: "/category" },
  { label: "专题", to: "/special" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || location.pathname !== "/";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 border-b border-background-200/80 backdrop-blur"
          : "bg-gradient-to-b from-background-50/80 to-transparent"
      }`}
    >
      <div className="container-page flex h-16 items-center justify-between md:h-20">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg leading-none text-accent-400 md:h-10 md:w-10 md:text-xl">
            戒
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base tracking-wide text-foreground-950 md:text-lg">
              色戒无删减版
            </span>
            <span className="mt-1 text-[10px] tracking-[0.26em] text-accent-500/90">LUST · CAUTION</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `relative rounded-md px-4 py-2 font-label text-sm transition-colors ${
                  isActive
                    ? "text-accent-400"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/detail/chapter-01"
            className="hidden items-center gap-2 rounded-md bg-accent-500 px-4 py-2 font-label text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-accent-600 sm:flex"
          >
            <i className="ri-play-fill text-base leading-none" />
            在线观看
          </Link>
          <button
            type="button"
            aria-label={menuOpen ? "收起菜单" : "展开菜单"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 bg-background-100/70 text-foreground-900 md:hidden"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-xl leading-none`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50/95 backdrop-blur md:hidden">
          <div className="container-page flex flex-col py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 font-label text-sm transition-colors ${
                    isActive ? "bg-primary-500/15 text-accent-400" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-base leading-none opacity-60" />
              </NavLink>
            ))}
            <Link
              to="/detail/chapter-01"
              className="mt-2 flex items-center justify-center gap-2 rounded-md bg-accent-500 px-4 py-3 font-label text-sm font-medium text-background-50"
            >
              <i className="ri-play-fill text-base leading-none" />
              在线观看
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}